import React from 'react';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import { JobsAnimation } from './JobsAnimation';

const JobsStageContainer = styled('div', {
  shouldForwardProp: (props) => props !== 'backgroundImage',
})<{ backgroundImage: string }>(({ backgroundImage }) => ({
  margin: 0,
  paddingTop: 110,
  width: '100%',
  height: 550,
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  position: 'relative',
  backgroundImage: `url(${backgroundImage})`,
}));

const SelectorContainer = styled(Container)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(3),
  backgroundColor: 'white',
  width: '90%',
  margin: '0 auto',
  left: 0,
  right: 0,
}));

interface JobsStageProps {
  backgroundImage?: string;
  showAnimation?: boolean;
  children?: React.ReactNode;
}

export const JobsStage: React.FC<JobsStageProps> = ({
  backgroundImage = '/assets/images/jobs/jobs-stage-1.webp',
  showAnimation = false,
  children,
}) => {
  return (
    <JobsStageContainer
      backgroundImage={backgroundImage}
      data-testid="jobs-stage"
    >
      {showAnimation && (
        <Container>
          <JobsAnimation />
        </Container>
      )}
      <SelectorContainer>{children}</SelectorContainer>
    </JobsStageContainer>
  );
};
